import { useHistory } from 'react-router-dom';
import I18n from 'i18n-js';

import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import BottomSheetDialog from '~/components/molecules/BottomSheetDialog';

import { RADAR_INTRO_PATH } from '~/views/RadarView/paths';
import { createNestedPath } from '~/views/RadarView/RadarRouter/utils';

import { ReactComponent as RadarIcon } from '~/assets/images/collections/chat-radar-large.svg';

import styles from './CollectionRankingRadarPopup.module.scss';

type TCollectionRankingRadarPopupProps = {
  close: () => void;
  collectionName: string;
};

export function CollectionRankingRadarPopup({
  close,
  collectionName,
}: TCollectionRankingRadarPopupProps): JSX.Element {
  const history = useHistory();

  return (
    <BottomSheetDialog
      onClose={close}
      header={collectionName}
      contentClassName={styles.container}
      elementIdToAnimate={null}
      renderFooter={({ closeDialog }) => {
        return (
          <div className={styles.footer}>
            <StyledButton
              variant={EStyledButtonVariant.GRAY}
              onClick={closeDialog}
              className={styles.footerButton}
            >
              {I18n.t('common_later')}
            </StyledButton>
            <StyledButton
              className={styles.footerButton}
              variant={EStyledButtonVariant.BLUE}
              onClick={() => {
                history.push(createNestedPath(RADAR_INTRO_PATH), {
                  skipFirstSlide: true,
                });
              }}
            >
              {I18n.t('common_lets_go')}
            </StyledButton>
          </div>
        );
      }}
    >
      <RadarIcon className={styles.icon} />
      <h2 className={styles.headline}>
        {I18n.t('collections_ranking_bs_radar_headline')}
      </h2>
      <p className={styles.text}>{I18n.t('collections_ranking_radar')}</p>
    </BottomSheetDialog>
  );
}
